<nav class="flex flex-col items-center gap-2 py-2xl h-full px-2">
  @for (entry of entries(); track entry.route) {
    <a
      [routerLink]="entry.route"
      [routerLinkActive]="['bg-background-highlight', 'hover:bg-background-highlight-hover']"
      [routerLinkActiveOptions]="entry.exact === false ? { exact: false } : exactMatch"
      class="w-full flex flex-col items-center gap-1 rounded-md py-2 text-text-accent hover:bg-background-default"
      [attr.data-testid]="'app-sidebar-link' + entry.route.replace('/', '-')"
    >
      <doka-icon [name]="entry.icon" size="2xl" />
      <span class="text-xs font-semibold">{{ entry.label | i18nextEager }}</span>
    </a>
  }
</nav>
